import * as React from 'react';
import { RichText } from 'prismic-reactjs';

import { Grid, Link, Typography, WithStyles, withStyles } from '@nelnet/unifi-components-react';

import styles from './styles';

interface ITwoColumnProps extends WithStyles<typeof styles> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  primary_usage_items?: Array<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  variations_examples?: Array<any>;
}

const TwoColumn: React.FunctionComponent<ITwoColumnProps> = ({
  classes,
  primary_usage_items,
  variations_examples,
}) => {
  if (primary_usage_items) {
    return (
      <Grid container spacing={4}>
        {primary_usage_items.map((usage_item, i) => {
          const do_not_use_graphic_url = usage_item.do_not_use_graphic
            ? usage_item.do_not_use_graphic.url
            : null;
          const do_not_use_graphic_alt = usage_item.do_not_use_graphic
            ? usage_item.do_not_use_graphic.alt
            : null;
          const do_not_use_text = usage_item.do_not_use_text;
          const use_graphic_url = usage_item.use_graphic ? usage_item.use_graphic.url : null;
          const use_graphic_alt = usage_item.use_graphic ? usage_item.use_graphic.alt : null;
          const use_text = usage_item.use_text;
          return (
            <React.Fragment key={i}>
              <Grid
                item
                sm={12}
                md={5}
                margin={{ top: 2, right: 6, bottom: 2, left: 2 }}
                padding={{ left: 2 }}
                className={classes.container}
              >
                <Typography variant="h4" align="left" className="bold">
                  Use
                </Typography>
                {use_graphic_url ? (
                  <Link underline="none">
                    <img src={use_graphic_url} alt={use_graphic_alt} className={classes.image} />
                  </Link>
                ) : null}
                <div className={classes.body}>{RichText.render(use_text)}</div>
              </Grid>
              <Grid
                item
                xs
                margin={{ top: 2, bottom: 4, left: 2 }}
                padding={{ left: 2 }}
                className={classes.container}
              >
                <Typography variant="h4" align="left" className="bold">
                  Do Not Use
                </Typography>
                {do_not_use_graphic_url ? (
                  <Link underline="none">
                    <img
                      src={do_not_use_graphic_url}
                      alt={do_not_use_graphic_alt}
                      className={classes.image}
                    />
                  </Link>
                ) : null}
                <div className={classes.body}>{RichText.render(do_not_use_text)}</div>
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
    );
  } else if (variations_examples) {
    return (
      <>
        <Grid container spacing={4}>
          {variations_examples.map((variations_item, i) => {
            const set_border =
              variations_item.primary.example_border == null ||
              variations_item.primary.example_border == 'border'
                ? 'border'
                : 'noBorder';
            const example_graphic_url = variations_item.primary.example_graphic
              ? variations_item.primary.example_graphic.url
              : null;
            const example_graphic_alt = variations_item.primary.example_graphic
              ? variations_item.primary.example_graphic.alt
              : null;
            const example_header = variations_item.primary.example_title
              ? variations_item.primary.example_title
              : null;
            const example_body = variations_item.primary.example_content;
            return (
              <React.Fragment key={i}>
                <Grid item sm={12} md={5} className={classes[`${set_border}`]}>
                  {example_header ? (
                    <Typography
                      variant="h4"
                      align="left"
                      className="bold"
                      padding={{ bottom: 1, left: 1 }}
                    >
                      {RichText.asText(example_header)}
                    </Typography>
                  ) : null}
                  {example_graphic_url ? (
                    <Link underline="none">
                      <img
                        src={example_graphic_url}
                        alt={example_graphic_alt}
                        className={classes.image}
                      />
                    </Link>
                  ) : null}
                  {example_body ? (
                    <div className={classes.exampleBody}>{RichText.render(example_body)}</div>
                  ) : null}
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      </>
    );
  }
};

export default withStyles(styles)(TwoColumn);
